import { areRoutesChangedPdsr } from "./AreRoutesChangedPdsr";
import { ProjectViewModel } from "../../../../ViewModel/ProjectViewModel";
import { LtlPipelineViewModel } from "../../../../ViewModel/LtlPipelineViewModel";

export function isDisabledForPdsr(
  pdsrId: number | undefined,
  project: ProjectViewModel,
  stopDataOfSpdrsOrPdsrs: number[],
  ltlPipeline?: LtlPipelineViewModel
) {
  const selectedLtlPdsrId = pdsrId;
  if (
    areRoutesChangedPdsr(
      selectedLtlPdsrId,
      project.FTLRoutes,
      project.TemplateFTLRoutes
    )
  ) {
    return true;
  }

  if (selectedLtlPdsrId && stopDataOfSpdrsOrPdsrs.includes(selectedLtlPdsrId)) {
    return true;
  }
  return (
    ltlPipeline !== undefined &&
    ltlPipeline.routing !== undefined &&
    ltlPipeline.routing.length > 0
  );
}
